/** How the next due date is computed after task completion (TIME conditions only). */
export const PreventiveMaintenanceTriggerBasis = {
  FLOATING: 'FLOATING',
  FIXED: 'FIXED',
} as const;

export type PreventiveMaintenanceTriggerBasis =
  (typeof PreventiveMaintenanceTriggerBasis)[keyof typeof PreventiveMaintenanceTriggerBasis];
